/**
 * DQ AI chatbot preview (research-team quality testing).
 * /v1/dq_ai/chatbot/* — public, no auth (REACT_APP_MYDQ_API already includes /v1).
 * Plain fetch on purpose: invokeApi's 401 handling force-logs-out, which must never
 * hit this login-free page.
 */

const baseUri = () => process.env.REACT_APP_MYDQ_API;

const asJson = async (res) => {
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error((body && body.message) || `Request failed (${res.status})`);
        err.status = res.status;
        throw err;
    }
    return body.data;
};

export const createDqAiSession = () => fetch(`${baseUri()}/dq_ai/chatbot/session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
}).then(asJson);

export const postDqAiMessage = ({ session_id, message }) => fetch(`${baseUri()}/dq_ai/chatbot/message`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id, message }),
}).then(asJson);

export const fetchDqAiSession = (session_id) => fetch(
    `${baseUri()}/dq_ai/chatbot/session?session_id=${encodeURIComponent(session_id)}`,
).then(asJson);
